import { type Reducer } from 'redux';

import { type setAbFlag, ACTIONS } from '@~/actions/ab-testing';

export interface IAbFeature {
  isEnabled: boolean;
  variant: string;
}

export interface IAbTestingState {
  [featureKey: string]: IAbFeature;
}

const initialState: IAbTestingState = {};

type TAbTestingReducer = Reducer<IAbTestingState, ReturnType<typeof setAbFlag>>;

const abTestingReducer: TAbTestingReducer = (state = initialState, action) => {
  const { type, payload } = action;

  if (type === ACTIONS.SET_AB_FLAG) {
    const { featureKey, isEnabled, variant = '' } = payload;

    return {
      ...state,
      [featureKey]: { isEnabled, variant },
    };
  }

  return state;
};

export default abTestingReducer;
